/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Connexion\ConnexionModule\ConnexionModule.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday December 11th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday December 11th 2023 4:20:25 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useEffect, useMemo, useRef, useState } from "react";
import ConnexionListMemo from "../ConnexionList/ConnexionList";
import TimeFilter from "../../TimeFilter/TimeFilter";
import UserService from "Services/Users/UserService";
import translator from "MultiLanguage/TranslationWrapper";
import { Button } from "@mui/material";
import { useIntersectionObserver } from "react-intersection-observer-hook";
import { ConnexionDataAndInfo, ConnexionRowType, CountConnexionType } from "Type/Connextion.type";
import ConnexionStats from "../ConnexionStats/ConnexionStats";
import Styles from "Content/Connexion/ConnexionModule/ConnexionModule.module.css";

type ConnexionModuleProps = {
    userID?: string,
    data: ConnexionRowType[],
    countConnexion: CountConnexionType,
    displayName: boolean,
    withAdmin?: boolean,
    order?: string,
    orderBy?: string,
    setOrderBy?: Function,
    setOrder?: Function
};

function ConnexionModule(props: ConnexionModuleProps) {
    const [page, setPage] = useState(0);
    const [myConnexion, setMyConnexion] = useState(props.data);
    const [nbConnexion, setNbConnexion] = useState(props.countConnexion);
    const timeFilter = useRef<{curActive: string, curOrder: string} | null>();
    const [ref, { entry }] = useIntersectionObserver();
    const isVisible = entry && entry.isIntersecting;

    useEffect(() => {
        setMyConnexion(props.data);
        setNbConnexion(props.countConnexion);
        if (page === 0)
            setPage(-1);
        else
            setPage(0);
    },[props.data]);

    useEffect(() => {
        if (isVisible)
            handleLoadMoreConnexion();
    }, [isVisible]);

    const itemsToShow = useMemo(() => {
        return [...myConnexion];
    }, [page]);

    function handleUpdateFilter(filters: {from: string, order: string}) {
        const url = window.location;
        setMyConnexion([]);
        UserService.getConnexions({...filters, userid: props.userID, withadmin: props.withAdmin})
        .then((res: ConnexionDataAndInfo) => {
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("page", "1");
            searchParams.set("order", filters.order);
            searchParams.set("orderby", filters.from);
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            setMyConnexion(res.connexion);
            setNbConnexion(res.count);
            if (page === 0)
                setPage(-1);
            else
                setPage(0);
        })
        .catch((error) => {
            console.error(error);
        });
    };

    function handleLoadMoreConnexion() {
        const url = window.location;
        const myParams = {
            page: 1,
            order: timeFilter?.current?.curOrder,
            from: timeFilter?.current?.curActive,
            userid: props.userID,
        };
        const searchParams = new URLSearchParams(url.search);
        if (searchParams.has("page"))
            myParams.page = parseInt(searchParams.get('page')!);
        myParams.page = myParams.page + 1;
        UserService.getConnexions(myParams)
        .then((res: ConnexionDataAndInfo) => {
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("page", myParams.page.toString());
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            setPage(myParams.page);
            setNbConnexion(res.count);
            setMyConnexion([...myConnexion, ...res.connexion]);
        })
        .catch((error) => {
            console.error(error);
        });
    };

    return (
        <>
            <div className={`${Styles.holderTopBar}`} >
                <ConnexionStats nbConnexion={nbConnexion.countConnexion} credential={nbConnexion.credential} refresh={nbConnexion.refresh} />
                <TimeFilter ref={timeFilter} handleUpdateFilter={handleUpdateFilter} order={props.order} orderBy={props.orderBy} setOrderBy={props.setOrderBy} setOrder={props.setOrder} />
            </div>
            <ConnexionListMemo data={itemsToShow} displayName={props.displayName} />
            {
                nbConnexion.countConnexion > 0 && myConnexion.length > 0 && myConnexion.length !== nbConnexion.countConnexion ?
                <Button ref={ref} className="p-2" onClick={handleLoadMoreConnexion}>{translator.decode("dynamic.more")}</Button>
                :null
            }
        </>
    );
};

export default ConnexionModule;
